import React from 'react';
export function IntroSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-439">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-left" data-id="element-440">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-white uppercase tracking-wide mb-6" data-id="element-441">
          Corporate Planning &amp; Emergency Preparedness
        </h2>
        <p className="text-xl text-brand-gray-300 leading-relaxed" data-id="element-442">
          Providing corporations and individual clients with a detailed,
          comprehensive approach to emergency planning is one of our highest
          priorities. With more than 20 years of experience, Medina Tactical
          Dynamics helps clients strengthen readiness through practical
          planning, sound strategy, and operational support tailored to
          real-world needs.
        </p>
        <p className="text-xl text-brand-gray-300 leading-relaxed" data-id="element-443">
          From strategic mapping and research to VIP protection, investigations,
          and personnel accountability, we focus on building preparedness
          programs that are thorough, actionable, and effective. Our team takes
          pride in implementing detailed operational planning concepts, strong
          protective strategies, and interactive training programs designed to
          improve confidence, coordination, and response.
        </p>
        <p className="text-xl text-brand-gray-300 leading-relaxed" data-id="element-444">
          Whether supporting a business, facility, or private client, our goal
          is to provide trusted consulting, meaningful guidance, and a stronger
          sense of security, readiness, and control.
        </p>
      </div>
    </section>;
}